module.exports = __webpack_public_path__ + "img/beer_id-74.31dc03b8.png";